import { Outlet, useParams } from "react-router-dom";
import { useDoctorDocumentReadiness } from "@hooks";
import { DoctorDocumentReadinessModal } from "./DoctorDocumentReadinessModal";

/**
 * Layout route for the steps that fill a document before its create screen,
 * like searching a medicine or writing a treatment: a doctor past their
 * validation deadline is stopped as soon as one opens, and closing the modal
 * takes them back to their requests.
 */
export function StopBlockedDoctor() {
  const { requestId } = useParams();
  const { modalProps } = useDoctorDocumentReadiness({
    requestId,
    stopBlockedOnOpen: true,
  });

  return (
    <>
      <Outlet />
      <DoctorDocumentReadinessModal {...modalProps} />
    </>
  );
}
